// Community Supervision Management APIs

/**
 * @function ApiClient#AddSupervisionRecord
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} supervisionRecordData
 * @param {any} options = {}
 */
export async function AddSupervisionRecord(cid, supervisionRecordData, options = {}) {
  return await this._post(`/community/${cid}/supervision_record`, supervisionRecordData, options);
}

/**
 * @function ApiClient#UpdateSupervisionRecord
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} supervisionRecordData
 * @param {any} options = {}
 */
export async function UpdateSupervisionRecord(cid, supervisionRecordData, options = {}) {
  return await this._put(`/community/${cid}/supervision_record`, supervisionRecordData, options);
}

/**
 * @function ApiClient#GetSupervisionRecordList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetSupervisionRecordList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/supervision_record_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

/**
 * @function ApiClient#DeleteSupervisionRecord
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vID
 * @param {any} options = {}
 */
export async function DeleteSupervisionRecord(cid, vID, options = {}) {
  return await this._delete(`/community/${cid}/supervision_record/${vID}`, options);
}
